import { api, authHeader } from "../configs/axiosConfigs";

const TicketsApiService = {
  // دریافت لیست تیکت‌های کاربر
  getUserTickets: async (filters = {}) => {
    try {
      const params = new URLSearchParams();
      if (filters.categoryId) params.append("categoryId", filters.categoryId);
      if (filters.status) params.append("status", filters.status);

      const response = await api.request({
        url: `/SLN/Tickets/GetUserTickets?${params.toString()}`,
        method: "GET",
        headers: authHeader(),
      });
      return response.data;
    } catch (error) {
      console.error("Error getting user tickets:", error);
      throw error;
    }
  },

  // دریافت لیست تمام تیکت‌ها (برای ادمین)
  getAllTickets: async (filters = {}) => {
    try {
      const params = new URLSearchParams();
      if (filters.categoryId) params.append("categoryId", filters.categoryId);
      if (filters.status) params.append("status", filters.status);

      const response = await api.request({
        url: `/SLN/Tickets/GetAllTickets?${params.toString()}`,
        method: "GET",
        headers: authHeader(),
      });
      return response.data;
    } catch (error) {
      console.error("Error getting all tickets:", error);
      throw error;
    }
  },

  // دریافت جزئیات یک تیکت
  getTicketDetail: async (ticketId) => {
    try {
      const response = await api.request({
        url: `/SLN/Tickets/GetTicketDetail/${ticketId}`,
        method: "GET",
        headers: authHeader(),
      });
      return response.data;
    } catch (error) {
      console.error("Error getting ticket detail:", error);
      throw error;
    }
  },

  // ایجاد تیکت جدید
  createTicket: async (ticketData) => {
    try {
      const response = await api.request({
        url: "/SLN/Tickets/CreateTicket",
        method: "POST",
        headers: authHeader(),
        data: ticketData,
      });
      return response.data;
    } catch (error) {
      console.error("Error creating ticket:", error);
      throw error;
    }
  },

  // افزودن پیام به تیکت
  addMessage: async (ticketId, messageData) => {
    try {
      const response = await api.request({
        url: `/SLN/Tickets/AddMessage/${ticketId}/messages`,
        method: "POST",
        headers: authHeader(),
        data: messageData,
      });
      return response.data;
    } catch (error) {
      console.error("Error adding message:", error);
      throw error;
    }
  },

  // افزودن پیام ادمین به تیکت
  addAdminMessage: async (ticketId, messageData) => {
    try {
      const response = await api.request({
        url: `/SLN/Tickets/AddAdminMessage/${ticketId}/admin-messages`,
        method: "POST",
        headers: authHeader(),
        data: messageData,
      });
      return response.data;
    } catch (error) {
      console.error("Error adding admin message:", error);
      throw error;
    }
  },

  // به‌روزرسانی وضعیت تیکت
  updateTicketStatus: async (ticketId, statusData) => {
    try {
      const response = await api.request({
        url: `/SLN/Tickets/UpdateTicketStatus/${ticketId}/status`,
        method: "PUT",
        headers: authHeader(),
        data: statusData,
      });
      return response.data;
    } catch (error) {
      console.error("Error updating ticket status:", error);
      throw error;
    }
  },

  // دریافت دسته‌بندی‌های تیکت
  getCategories: async () => {
    try {
      const response = await api.request({
        url: "/SLN/Tickets/GetCategories",
        method: "GET",
        headers: authHeader(),
      });
      return response.data;
    } catch (error) {
      console.error("Error getting categories:", error);
      throw error;
    }
  },

  // دریافت آمار تیکت‌ها
  getStatistics: async () => {
    try {
      const response = await api.request({
        url: "/SLN/Tickets/GetStatistics",
        method: "GET",
        headers: authHeader(),
      });
      return response.data;
    } catch (error) {
      console.error("Error getting statistics:", error);
      throw error;
    }
  },

  // دریافت تعداد تیکت‌های خوانده نشده
  getUnreadCount: async () => {
    try {
      const response = await api.request({
        url: "/SLN/Tickets/GetUnreadCount",
        method: "GET",
        headers: authHeader(),
      });
      return response.data;
    } catch (error) {
      console.error("Error getting unread count:", error);
      throw error;
    }
  },
};

export default TicketsApiService;